import { useProductCard } from 'product-card/hooks/useProductCard'
import { useProductImages } from 'product-card/hooks/useProductImages/useProductImages'
import { useShowAsFeatured } from 'product-card/hooks/useShowAsFeatured/useShowAsFeatured'
import { getPanoramicImage } from 'product-card/utils/getPanoramicImage/getPanoramicImage'
import { sortImagesByOrder } from 'product-card/utils/sortImagesByOrder'
import { useMemo } from 'react'

export const useSortedProductImages = () => {
	const { imageSortCriteria } = useProductCard()
	const showAsFeatured = useShowAsFeatured()
	const images = useProductImages()

	return useMemo(() => {
		if (showAsFeatured) {
			return [getPanoramicImage(images)]
		}
		return sortImagesByOrder(images, imageSortCriteria)
	}, [images, imageSortCriteria, showAsFeatured])
}
